
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Button, Form, ListGroup, Container, Row, Col, Alert } from 'react-bootstrap';

const TransferDocuments = () => {
    const [modules, setModules] = useState([]);
    const [sourceModule, setSourceModule] = useState('');
    const [destinationModule, setDestinationModule] = useState('');
    const [documents, setDocuments] = useState([]);
    const [selectedDocuments, setSelectedDocuments] = useState([]);
    const [message, setMessage] = useState('');

    useEffect(() => {
        axios.get(`${process.env.REACT_APP_API_URL}/api/modules`)
            .then(res => setModules(res.data))
            .catch(err => console.log(err));
    }, []);

    useEffect(() => {
        if (sourceModule) {
            axios.get(`${process.env.REACT_APP_API_URL}/api/documents/${sourceModule}`)
                .then(res => setDocuments(res.data))
                .catch(err => console.log(err));
        } else {
            setDocuments([]);
        }
    }, [sourceModule]);

    const handleCheckboxChange = (docId) => {
        setSelectedDocuments(prev =>
            prev.includes(docId) ? prev.filter(id => id !== docId) : [...prev, docId]
        );
    };

    const handleTransfer = () => {
        if (selectedDocuments.length === 0 || !destinationModule) {
            setMessage({ type: 'danger', text: 'Veuillez sélectionner des documents et un module de destination.' });
            return;
        }

        if (sourceModule === destinationModule) {
            setMessage({ type: 'danger', text: 'Le module source et le module de destination ne peuvent pas être identiques.' });
            return;
        }

        axios.post(`${process.env.REACT_APP_API_URL}/api/documents/transfer`, {
            documentIds: selectedDocuments,
            destinationModuleId: destinationModule
        })
        .then(res => {
            setMessage({ type: 'success', text: res.data.msg });
            // Refresh documents for the source module
            axios.get(`${process.env.REACT_APP_API_URL}/api/documents/${sourceModule}`)
                .then(res => setDocuments(res.data))
                .catch(err => console.log(err));
            setSelectedDocuments([]);
        })
        .catch(err => {
            setMessage({ type: 'danger', text: 'Une erreur est survenue lors du transfert.' });
            console.log(err);
        });
    };

    return (
        <Container className="mt-4">
            <h2>Transférer des documents</h2>
            {message && <Alert variant={message.type}>{message.text}</Alert>}
            <Row>
                <Col md={6}>
                    <Form.Group>
                        <Form.Label><strong>1. Choisir le module source</strong></Form.Label>
                        <Form.Control as="select" value={sourceModule} onChange={e => setSourceModule(e.target.value)}>
                            <option value="">Sélectionnez un module</option>
                            {modules.map(m => <option key={m.id} value={m.id}>{m.nom}</option>)}
                        </Form.Control>
                    </Form.Group>
                    <hr />
                    {documents.length > 0 && (
                        <ListGroup>
                            {documents.map(doc => (
                                <ListGroup.Item key={doc.id}>
                                    <Form.Check
                                        type="checkbox"
                                        label={`${doc.nom} (${doc.type_document})`}
                                        checked={selectedDocuments.includes(doc.id)}
                                        onChange={() => handleCheckboxChange(doc.id)}
                                    />
                                </ListGroup.Item>
                            ))}
                        </ListGroup>
                    )}
                </Col>
                <Col md={6}>
                    <Form.Group>
                        <Form.Label><strong>2. Choisir le module de destination</strong></Form.Label>
                        <Form.Control as="select" value={destinationModule} onChange={e => setDestinationModule(e.target.value)}>
                            <option value="">Sélectionnez un module</option>
                            {modules.filter(m => m.id !== parseInt(sourceModule)).map(m => <option key={m.id} value={m.id}>{m.nom}</option>)}
                        </Form.Control>
                    </Form.Group>
                    <hr />
                    <Button onClick={handleTransfer} disabled={selectedDocuments.length === 0 || !destinationModule}>
                        Transférer les documents sélectionnés
                    </Button>
                </Col>
            </Row>
        </Container>
    );
};

export default TransferDocuments;
